<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card min-height="200">
        <v-card-text>
          <v-text-field
            v-model="number"
            type="text"
            :label="$t('change_pallet_number_dialog.number')"
          ></v-text-field>
        </v-card-text>
        <div class="confirm-button">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn color="green" @click="save()" v-on="on">
                <v-icon color="white">done</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("truck_maker.confirm") }}</span>
          </v-tooltip>
        </div>
        <div class="cancel-button">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn color="red" @click="dialog = false" v-on="on">
                <v-icon color="white">close</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("pallets_maker.cancel") }}</span>
          </v-tooltip>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      number: "",
      pallet: null,
      onKeyUp: e => {
        if (e.key === "Escape") {
          this.dialog = false;
        }
        if (e.key === "Enter") {
          this.save();
        }
      }
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.keyUpHandler = this.onKeyUp.bind(this);
        document.addEventListener("keyup", this.keyUpHandler);
      } else {
        this.pallet = null;
        document.removeEventListener("keyup", this.keyUpHandler);
      }
    }
  },
  methods: {
    open(pallet) {
      this.dialog = true;
      this.number = pallet.number;
      this.pallet = pallet;
    },
    async save() {
      const response = await this.pallet.updateNumber(this.number);
      if (response) {
        this.dialog = false;
        this.$emit("updated")
      }
    }
  }
};
</script>

<style scoped>
#pallet-3d {
  position: absolute;
  margin-left: 25px;
  width: 700px;
  height: 200px;
}
</style>